
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/image-splitter",
      function () {
        return require("private-next-pages/image-splitter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/image-splitter"])
      });
    }
  